import { render, staticRenderFns } from "./DormantClientsModal.vue?vue&type=template&id=d586101e&scoped=true"
import script from "./DormantClientsModal.vue?vue&type=script&lang=js"
export * from "./DormantClientsModal.vue?vue&type=script&lang=js"
import style0 from "./DormantClientsModal.vue?vue&type=style&index=0&id=d586101e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d586101e",
  null
  
)

export default component.exports